import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapDropdownSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapdropdown: {
      group: 'block',
      content: 'madcapdropdownhead madcapdropdownbody',
      parseDOM: [{ tag: 'MadCap\\:dropDown' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:dropDown',
      specContent: 'madcapdropdownhead madcapdropdownbody'
    },

    madcapdropdownhead: {
      content: 'block+',
      defining: true,
      fillIfContentDeleted: 'mcCentralContainer',
      linkBucket: 'dropdown',
      parseDOM: [{ tag: 'MadCap\\:dropDownHead' }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:dropDownHead',
      specContext: 'madcapdropdown'
    },

    madcapdropdownbody: {
      content: 'block+',
      defining: true,
      isolating: true,
      fillIfContentDeleted: 'mcCentralContainer',
      linkBucket: 'dropdown',
      parseDOM: [{ tag: 'MadCap\\:dropDownBody' }],
      toDOM(node) {
        const outputSpec = nodeToDOM(node);
        // Make non-editable by default. This works in conjunction with the node view.
        outputSpec.dom.setAttribute('contenteditable', 'false');
        return outputSpec;
      },
      tagName: 'MadCap:dropDownBody',
      specContext: 'madcapdropdown'
    },

    madcapdropdownhotspot: {
      group: 'block',
      content: 'block+',
      fillIfContentDeleted: 'mcCentralContainer',
      linkBucket: 'dropdown',
      parseDOM: [{
        tag: 'MadCap\\:dropDownHotspot',
        context: 'madcapdropdownhead//' // Must be within a madcapdropdownhead
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:dropDownHotspot',
      specContext: 'madcapdropdownhead'
    }
  } satisfies Record<string, NodeSpec>;
}
